/**
 * Sentry SDK init for the React frontend.
 *
 * No-op when REACT_APP_SENTRY_DSN is unset (preview/local default).
 * Imported once from src/index.js BEFORE the App tree mounts so we capture
 * render-phase errors as well as runtime exceptions.
 */
import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry() {
  if (initialized) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'preview';
  const release = process.env.REACT_APP_SENTRY_RELEASE || 'wave-dsp-web@unknown';
  const tracesSampleRate = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.05');

  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate,
    // Capture session replay for sessions that include errors so we can
    // walk through what the user was doing when something broke.
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // Drop noisy network errors that aren't actionable
    beforeSend(event, hint) {
      const err = hint?.originalException;
      const msg = err?.message || event?.message || '';
      if (typeof msg === 'string' && /Failed to fetch|NetworkError|Load failed/i.test(msg)) {
        return null;
      }
      return event;
    },
  });
  initialized = true;
}

export { Sentry };
